import { useQuery } from '@tanstack/react-query';
import { getTenants } from '../../api/tenants/getTenants';
import { useEnvironment } from '../useEnvironment/useEnvironment';

export const useGetTenants = () => {
  const { environment } = useEnvironment();
  return useQuery({
    queryKey: ['tenants', environment],
    queryFn: () => getTenants(environment),
    select: ({ data }) => data,
  });
};
